<app-lms-modal-frame [title]="'Codix Offers'" [pageHeadWidth]="500">
  <div modal-body>
  <div class="card">
    <div class="card-body p-2">
      <div class="d-flex center-screen">
        <table class="table table-auto table-bordered table-hover table-striped table-sm shadow-2-strong rounded-1 p-1">
          <thead>
            <tr class="table-center-header">
              <th class="with-override">Product</th>
              <th class="with-override">Outcome</th>
              <th>Reason</th>
              <th [ngClass]="{'with-override':(withOverride === true)}" *ngIf="withOverride === true">Override</th>
            </tr>
          </thead>
          <tbody>
            <!-- *ngIf="clientResults.loans"> -->
            <ng-container *ngFor="let compOffers of compuscanOffers; let i = index">
              <tr [ngClass]="{ 'no-override': (!compOffers.overrideRequested && !compOffers.overrideApplied) }">
                <td class="ps-3 fs-7 fw-bold text-start text-nowrap">{{compOffers.description ?? compOffers.productDescription}}</td>
                <td class="text-center">
                    <label [ngClass]="{'badge-success': (compOffers.outcome === 'Y' || compOffers.outcome === 'Approve'|| (compOffers.overrideApplied === true && withOverride === true)), 'badge-danger': (compOffers.outcome != 'Y' && compOffers.outcome != 'Approve' && compOffers.overrideApplied !== true)}" class="badge  text-medium rounded-pill d-inline"> {{compOffers.overrideApplied === true && withOverride === true ? 'Approved' : compOffers.outcome}} </label>
                </td>
                <td class="text-small text-start text-wrap ">{{compOffers.reason ?? compOffers.reasons?.reason?.value ?? '-'}}</td>
                <td class="text-center text-danger" *ngIf="compOffers.overrideRequested && !compOffers.overrideApplied && withOverride === true">
                    <i class="fas fa-circle-xmark"></i> Requested
                </td>
                <td class="text-center text-success" *ngIf="compOffers.overrideApplied === true && withOverride === true">
                    <i class="fas fa-circle-check"></i> Approved
                </td>
                <td class="text-center " [ngClass]="{ 'col-ovr': compOffers.overrideRequested === false && withOverride === true }" *ngIf="withOverride === true && !(compOffers.outcome == 'Y' || compOffers.outcome == 'Approve') && compOffers.overrideRequested === false">
                  <button class="btn btn-floating hover-btn" (click)="overrideOffer(compOffers)">
                    <i class="fas fa-money-bill-trend-up"></i> </button>
                </td>
              </tr>
            </ng-container>
          </tbody>
        </table>
      </div>
    </div>
    </div>
  </div>
  <div modal-actions class="flex-container center-screen">
    <button type="button" class="btn btn-primary w-50" mdbRipple (click)="close()">Close</button>
  </div>
</app-lms-modal-frame>
